module.exports = __webpack_public_path__ + "static/depoimento 4-68dd04ac536768986c7db2b5c5061b48.svg";